import SelectTableFilter from 'components/atoms/select-table-filter'
import CustomerOrderShipmentStatusBadge from 'domains/customer-order/atoms/shipment-status-badge'
import { SHIPMENT_STATUS } from 'domains/customer-order/constants'
import React from 'react'
import PriceUtil from 'utils/price-util'
import RowButton from 'components/atoms/row-button'

const customerOrderShipmentTableColumns = (onButtonClick) => {
  // Custom Filter
  // Used to modify the filter in specific columns
  // eslint-disable-next-line react/prop-types
  const StatusFilter = ({ column }) => {
    const options = Object.keys(SHIPMENT_STATUS).map((key) => (
      {
        label : SHIPMENT_STATUS[key],
        value : SHIPMENT_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const PriceCell  = (row) => PriceUtil.format(row.cell.value)
  const StatusCell = (row) => <CustomerOrderShipmentStatusBadge status={ row.cell.value } />
  const WeightCell = (row) => <div>
    <div>{ row.cell.value + ' kg' }</div>
    <div>{ row.row.original.weight_type }</div>
  </div>

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      colour="primary"
      onClick={ onButtonClick }
      text="Detail"
    />
  )
  return (
    [
      {
        Header         : 'Number',
        accessor       : 'number',
        disableFilters : true
      },
      {
        Header   : 'Courier',
        accessor : 'courier'
      },
      {
        Header         : 'Service Type',
        accessor       : 'courier_service_type',
        disableFilters : true
      },
      {
        Header   : 'Tracking Number',
        accessor : 'tracking_no'
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Filter   : StatusFilter,
        Cell     : StatusCell
      },
      {
        Header         : 'Weight',
        accessor       : 'weight',
        disableFilters : true,
        Cell           : WeightCell
      },
      {
        Header         : 'Cost',
        accessor       : 'cost',
        disableFilters : true,
        Cell           : PriceCell
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default customerOrderShipmentTableColumns